import React, {Component} from 'react';
import {Grid, Row, Col} from 'react-bootstrap'
import _ from 'lodash'
import moment from 'moment-timezone'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {retrieveTestsInRange} from '../../../actions/index'
import ReportTestView from './ReportTestView'
import AnnualReportsView from './AnnualReportsView'
import Load from '../../Load'
import {renderTestFields, downloadLink} from '../../../constants'
import {timezone} from '../../../constants'

_.mixin({
    mapIds: (obj, arr) => {
        arr.forEach(a => obj[a.id] = a)
        return obj
    }
})

export default class ReportView extends Component {

    constructor(props) {
        super(props)

        const end = moment().tz(timezone)
        const start = moment(end).add({months: -1})
        this.state = {
            startDate: start,
            endDate: end
        }
    }

    dateChange = (moment, fieldName) => {
        let state = (this.state || {})
        state[fieldName] = moment
        this.setState(state)
        //this.refs[fieldName] = moment
    }

    getTests = () => {
        this.props.dispatch(retrieveTestsInRange(this.state.startDate, this.state.endDate, true, true))
    }

    exportCSV = () => {

        const engines = [];
        const plannedEngines = [];
        [1,2,3,4].forEach(i => {
            ['Idle', 'Med', 'High'].forEach(p => {
                engines.push({field: `e${i}${p}`, title: `E${i}${p}`})
                plannedEngines.push({field: `plannedE${i}${p}`, title: `Planned E${i}${p}`})
            })
        });

        const csvFields = [{field: "ref", title: "Reference"},
            {field: "startedAt", title: "Date/time"},
            {field: "schedulerName", title: "Scheduler name"},
            {field: "testerName", title: "Tester name"},
            {field: "aircraft", title: "Aircraft type"},
            {field: "aircraftRegistration", title: "Aircraft registration"},
            {field: "power", title: "Max power tested"},
            {field: "departure", title: "Scheduled departure time"},
            {field: "status", title: "Status"},
            {field: "heading", title: "Heading"},
            //{field: "id", title: "ID"},
            {field: "duration", title: "Duration"},
            ...engines,
            //{field: "owner", title: "Owner"},
            {field: "group", title: "Maintenance agency"},
            {field: "antarctic", title: "Antarctic"},
            {field: "naturalDisaster", title: "Natural disaster"},
            {field: "approved", title: "Approved"},
            {field: "unplanned", title: "Unplanned"},
            {field: "runway11InUse", title: "Runway 11 in use"},
            {field: "lightMaintenance", title: "Light maintenance"},
            {field: "heavyMaintenance", title: "Heavy maintenance"},
            {field: "maxSimultaneousHighPower", title: "Max. simultaneous high power engines"},
            {field: "otherOperator", title: "Other operator"},
            {field: "otherAircraft", title: "Other aircraft"},
            {field: "reason", title: "Reason"},
            {field: "weather", title: "Weather"},
            {field: "approvalDoc", title: "Approval doc"},
            {field: "scheduledDeparture", title: "Scheduled departure"},
            {field: "firstEngineOn", title: "First engine on"},
            {field: "lastEngineOff", title: "Last engine off"},
            {field: "location", title: "Location"},
            {field: "operator", title: "Operator"},
            {field: "didPrint", title: "Did print"},
            {field: "plannedDuration", title: "Planned duration"},
            ...plannedEngines,
            {field: "plannedRunway11InUse", title: "Planned Runway 11 in use"},
            {field: "plannedLightMaintenance", title: "Planned light maintenance"},
            {field: "plannedHeavyMaintenance", title: "Planned heavy maintenance"},
            {field: "plannedUnplanned", title: "Planned unplanned"},
            {field: "plannedAntarctic", title: "Planned antarctic"},
            {field: "plannedNaturalDisaster", title: "Planned Natural disaster"},
            {field: "plannedApproved", title: "Planned approved"},
            {field: "plannedMaxSimultaneousHighPower", title: "Planned max. simultaneous high power engines"},
            {field: "plannedOtherOperator", title: "Planned other operator"},
            {field: "plannedOtherAircraft", title: "Planned other aircraft"},
            {field: "plannedAircraftRegistration", title: "Planned aircraft registration"},
            {field: "plannedReason", title: "Planned reason"},
            {field: "plannedWeather", title: "Planned weather"},
            {field: "plannedSchedulerName", title: "Planned scheduler name"},
            {field: "plannedTesterName", title: "Planned tester name"},
            {field: "plannedApprovalDoc", title: "Planned approval doc"},
            {field: "plannedStartedAt", title: "Planned started at"},
            {field: "plannedScheduledDeparture", title: "Planned scheduled departure"},
            {field: "plannedFirstEngineOn", title: "Planned first engine on"},
            {field: "plannedLastEngineOff", title: "Planned last engine off"},
        ]

        const mappedGroups = _.mapIds({}, (this.props.groups || []).map(g => g.group))
        const mappedUsers = _.mapIds({}, _.flatten((this.props.groups || []).map(g => g.users)))

        const header = csvFields.map(f => f.title).join(',')
        const rows = this.props.tests.map(test => {
            const fields = renderTestFields(test, true, false, false, false, false, mappedGroups, mappedUsers)
            return csvFields.map(f => fields[f.field]).join(',')
        })
        const csv = [header, ...rows].join('\n')
        //console.log('csv',csv)
        downloadLink(csv, 'ETMS test report.csv')
    }

    render() {
        //console.log('AdminReportView', this.props)

        const s = this.state || {}
        return <div className="groups-container">

            <Grid fluid>
                <Row>
                    <Col xs={12} md={6} className="groups-header">ENGINE TESTS REPORT</Col>
                    <Col xs={12} md={6} />
                </Row>

                <Row>
                    <Col xs={12} md={2}>Report start date</Col>
                    <Col xs={12} md={4}>
                        <DatePicker
                            selected={s.startDate}
                            selectsStart
                            startDate={s.startDate}
                            endDate={s.endDate}
                            //isClearable={true}
                            dateFormat="DD/MM/YYYY"
                            showMonthDropdown
                            showYearDropdown
                            scrollableYearDropdown
                            withPortal
                            monthsShown={1}
                            onChange={(m) => this.dateChange(m, 'startDate')} /></Col>
                    <Col xs={12} md={2}>Report end date</Col>
                    <Col xs={12} md={4}>
                        <DatePicker
                            selected={s.endDate}
                            selectsEnd
                            startDate={s.startDate}
                            endDate={s.endDate}
                            //isClearable={true}
                            dateFormat="DD/MM/YYYY"
                            showMonthDropdown
                            showYearDropdown
                            scrollableYearDropdown
                            withPortal
                            monthsShown={1}
                            onChange={(m) => this.dateChange(m, 'endDate')} />
                    </Col>
                </Row>
            </Grid>

            <div className="" style={{marginTop: '10px', marginBottom: '20px'}}>
                <button className="inline-block link no-underline" onClick={this.getTests}>
                    Get tests
                </button>
            </div>


            <Grid fluid>

                {this.props.loading['retrieveTestsInRange'] && <Load />}

                {this.props.tests.length > 0 && <Row className="test-grid-header">
                    <Col xs={1}>
                        REF
                    </Col>
                    <Col xs={2}>
                        DATE/TIME
                    </Col>
                    <Col xs={2}>
                        TESTER NAME
                    </Col>
                    <Col xs={1}>
                        AIRCRAFT TYPE
                    </Col>
                    <Col xs={1}>
                        AIRCRAFT REGISTRATION
                    </Col>
                    <Col xs={1}>
                        MAX POWER TESTED
                    </Col>
                    <Col xs={2}>
                        SCHD. DEPARTURE TIME
                    </Col>
                    <Col xs={2}>
                        TEST STATUS
                    </Col>
                </Row>}

                {!this.props.loading['retrieveTestsInRange'] && _.sortBy(this.props.tests, ['startedAt']).map(test => <ReportTestView key={test.id} test={test} />)}

                {this.props.tests.length > 0 && <div>
                    <button className="inline-block link no-underline" onClick={this.exportCSV}>
                        Export tests as CSV
                    </button>
                </div>}
            </Grid>

            <AnnualReportsView
                dispatch={this.props.dispatch}
                loading={this.props.loading}
                report={this.props.report}
                MDAYearly={this.props.MDAYearly}
            />

        </div>

    }
}







// WEBPACK FOOTER //
// ./src/components/admin/report/ReportView.jsx